export default "__VITE_ASSET__083668bd__"